/**
 * API constant specific for the chat library.
 */
export const CHAT_API = {
  BASE_URL: 'https://',
  CHAT_SEARCH_LIST: '/4.1/chat/search-list',
  OTHER_USER_INFO: '/4.3/chat/other-user-info',
}
